export const MuiFormHelperText = {
  styleOverrides: {
    root: {},
  },
};
